import { HttpClient } from '../clientFactory/unpack/types'

import ModifyBookingActions from './modfiyBooking/ModifyBookingActions'

const ModifyBookingClient = (client: HttpClient) => new ModifyBookingActions(client)
export default ModifyBookingClient
